import React from 'react';
import {useComputedReservationDetails} from '../../../context/computedReservationDetails';
import {loadWelcomePickups} from '../../../scripts';
import {useTranslation} from 'react-i18next';
import withChangeLanguage from './withChangeLanguage';

const rootDivId = 'welcomepickups';

const widgetConfig = {
  property_group_id: 975,
  to_location_id: 18972,
  button_color: '#2D3B4E',
};

function Widget() {
  const {i18n} = useTranslation();
  const {isReservationLoaded} = useComputedReservationDetails();

  const loadConfigScript = React.useCallback((callback: any) => {
    const node = document.getElementById(rootDivId);

    const configScript = document.createElement('script');
    configScript.type = 'text/props';
    configScript.id = 'configScriptId';
    configScript.async = true;
    configScript.innerText = JSON.stringify(widgetConfig);
    node?.appendChild(configScript);

    return callback();
  }, []);

  React.useEffect(() => {
    if (!isReservationLoaded) return;
    return loadConfigScript(loadWelcomePickups);
  }, [isReservationLoaded, loadConfigScript]);

  return <div data-prop-locale={i18n.language} id="welcomepickups"></div>;
}

const WelcomePickupsWidget = withChangeLanguage(Widget);
export {WelcomePickupsWidget};
